import { render, staticRenderFns } from "./InserirAtualizarDotacaoEmMassaForm.vue?vue&type=template&id=89cce3a4"
import script from "./InserirAtualizarDotacaoEmMassaForm.vue?vue&type=script&lang=js"
export * from "./InserirAtualizarDotacaoEmMassaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports